import { BookingPeriod } from '@spiaggeit/spit-datepicker'
import { z } from 'zod'

import { HalfDay } from '@/models/insertPeriod'

export const HALF_DAY_QUERY_PARAM = 'hd'

export function getHalfDayValueFromBookingPeriod(
  bookingPeriod: BookingPeriod | null
): HalfDay {
  switch (bookingPeriod) {
    case BookingPeriod.ALL_SEASON:
    case BookingPeriod.ALL_DAY:
      return 0
    case BookingPeriod.MORNING:
      return 1
    case BookingPeriod.AFTERNOON:
      return 2
    default:
      return 0
  }
}

export function getBookingPeriodFromHalfDay(value: HalfDay): BookingPeriod {
  if (Number.isNaN(value)) {
    return BookingPeriod.ALL_DAY
  }

  switch (value) {
    case 0:
      return BookingPeriod.ALL_DAY
    case 1:
      return BookingPeriod.MORNING
    case 2:
      return BookingPeriod.AFTERNOON
    default:
      return BookingPeriod.ALL_DAY
  }
}

const halfDayValidator = z.union([z.literal(0), z.literal(1), z.literal(2)])

export function getHalfDayValueFromQueryString(
  qs: URLSearchParams
): HalfDay | null {
  const hd = qs.get('hd')
  if (!hd) return null
  const value = halfDayValidator.safeParse(Number(hd))
  if (!value.success) {
    return null
  }
  return value.data
}
